window.addEventListener('load', function () {
  const Swiper = window.Swiper;
  const carousel = document.querySelector('.related-flavors__carousel');

  if (carousel) {
    new Swiper('.related-flavors__carousel', {
      direction: 'horizontal',
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchOverflow: true,
      spaceBetween: 20,
      loop: true,

      pagination: {
        el: '.related-flavors__carousel .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.related-flavors__carousel__arrows .swiper-button-next',
        prevEl: '.related-flavors__carousel__arrows .swiper-button-prev',
      },
      breakpoints: {
        450: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
          slidesPerGroup: 1,
          centeredSlides: true,
        },
        1080: {
          slidesPerView: 4.2,
          spaceBetween: 40,
          slidesPerGroup: 1,
          centeredSlides: true,
        },

        1320: {
          slidesPerView: 4,
          spaceBetween: 80,
          slidesPerGroup: 1,
          centeredSlides: true,
        },
      },
    });
  }
});
